import Axios from 'axios';

export default async function getAddress(lat, lng) {
  try {
    const response = await Axios.get(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
    );
    const address = response.data.display_name;
    return address;
  } catch {
    return 'geocode error';
  }
}
